class PredictiveSearchMobile extends PredictiveSearch {
  constructor() {
    super();
  }

  initSlider() {
    return;
  }

  clickOutside() {
    return;
  }

  open() {
    this.predictiveSearchResults.classList.add('is-open');

    bodyScroll.lock(this.predictiveSearchResults);
  }
}

customElements.define('predictive-search-mobile', PredictiveSearchMobile);
